export enum ATTRACTION_TYPE {
    AIRPORT = "AIRPORT",
    TRAIN_STATION = "TRAIN_STATION",
    BUS_STATION = "BUS_STATION",
    HOSPITAL = "HOSPITAL",
    PUBLIC_BEACH = "PUBLIC_BEACH",
    PHARMACY = "PHARMACY",
    GROCERY_STORE = "GROCERY_STORE",
}
